import { Component, OnInit } from '@angular/core'
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { HhgCarrierRateFilingService } from 'src/app/features/hhg-carrier-rate-filing/hhg-carrier-rate-filing.service';
import { AlertService } from 'src/app/services/alert/alert.service';
import { LoadingService } from 'src/app/services/loading/loading.service';
import { IffShipmentDetailsService } from 'src/app/services/iff-shipment-details/iff-shipment-details.service';
import AppConstants, {TransTypes as TT, CarrierApprovalInfo as CAI} from '../../../shared/common-components/AppConstants';


@Component({
    selector: 'app-negative-shipment-report-submission',
    templateUrl: './negative-shipment-report-submission.component.html',
    styleUrls: ['./negative-shipment-report-submission.component.css'],
    standalone: false
})
export class NegativeShipmentReportSubmissionComponent implements OnInit {
  public carrierTSPsList = [];
  public reportingYrQuarterList = [];
  public errorMessage = '';
  public reportSubmissionSuccess = false;
  public reportSubmissionFailure = false;
  public showCarrierTSPs = true;
  public reportMessage = '';
  public reportStatus: any;
  transTypeList: any[] = [];
  transTypeDomestic: boolean = false;
  transTypeInternational: boolean = false;
  movingTypeList: any[] = [
    { name: 'HHG', value: 'HHG' },
    { name: 'SIT', value: 'SIT' }
  ];
  carrierApprovalInfo: any[] = [];
  carrierId: any;
  negativeShipmentSubmissionGroup!: UntypedFormGroup;
  suppressedTransType:boolean[] = [false, false];
  staticTransTypeList = [
    { name: TT.GENERALDOMESTIC, value: TT.GENERALDOMESTIC },
    { name: TT.DOMESTICMOVEMANAGEMENT, value: TT.DOMESTICMOVEMANAGEMENT },
    { name: TT.GENERALINTERNATIONAL, value: TT.GENERALINTERNATIONAL },
    { name: TT.INTERNATIONALMOVEMANAGEMENT, value: TT.INTERNATIONALMOVEMANAGEMENT }
  ];
  hideGeneralDomesticTransType: boolean = false;
  hasMcNumber: boolean = false;
  constructor(private iffShipmentDetailsService: IffShipmentDetailsService,
    private hhgCarrierRateFilingService: HhgCarrierRateFilingService,
    private fb: UntypedFormBuilder,
    private alertService: AlertService,
    private loader: LoadingService,
    private route: ActivatedRoute) {
    this.loader = loader;

    /**
   *  getting current user from the behavioural subject
   */
    this.loader.show();
    this.hhgCarrierRateFilingService.getCarrierIdByUser().subscribe(carrierId => {
      this.carrierId = carrierId;
      if (this.carrierId !== undefined && this.carrierId !== null) {
        this.loadCarrierApprovalInfo(this.carrierId);
      }
      this.loader.hide();
    }, (error) => {
      this.loader.hide();
      this.alertService.error('Unable to load TSP info values. Please try again later or contact system administrator');
      console.log(error);
    });
  }

  /**
 * @description initializes negativeShipmentSubmission form
 */
  initializeForm() {
    this.negativeShipmentSubmissionGroup = this.fb.group({
      reportingYrQuarterSelect: new UntypedFormControl('', Validators.required),
      carrierTSPSelect: new UntypedFormControl('', Validators.required),
      moveTypeSelect: new UntypedFormControl('', Validators.required),
      transTypeSelect: new UntypedFormControl('', Validators.required)

    });
  }
  ngOnInit() {
    this.initializeForm();
    this.loader.show();

    //This to load list boxes from Negative Shipment Submission Report
    this.iffShipmentDetailsService.getNegativeShipmentSelectOptions()
      .subscribe(selectData => {
        debugger
        this.carrierTSPsList = selectData.scacTSPsList.sort((a: any, b: any) => a.name > b.name ? 1 : -1);
        const carrierTSPControl = this.negativeShipmentSubmissionGroup.get('carrierTSPSelect');
        if (this.carrierTSPsList.length === 0) {
          this.carrierTSPsList = [];
          this.showCarrierTSPs = false;
          if (carrierTSPControl) {
            carrierTSPControl.setValidators([]);
            carrierTSPControl.updateValueAndValidity();
          }
        } else {
          if (carrierTSPControl) {
            carrierTSPControl.setValidators([Validators.required]);
            carrierTSPControl.updateValueAndValidity();
          }
          this.showCarrierTSPs = true;
        }
        this.reportingYrQuarterList = selectData.reportingYearQuarterList;
      },
        (error) => {
          this.errorMessage = error;
          console.log('No records found for the negative shipment report list boxes: ' + error);
          this.alertService.error('No records found for the negative shipment report list boxes ');

          this.loader.hide();
        }, () => {
          console.log('Successfully select options list details: ');
          this.loader.hide();
        }
      );
  }

  shouldHideGeneralDomesticTransType(carrierApproval: any) {
      if(carrierApproval.approvalType === CAI.DOMESTICHHG && AppConstants.isNotNullCondition(carrierApproval.mcNumber))
        this.hasMcNumber = true;
      else
        this.hasMcNumber = false;
  }
  /**
   * getting carrier approval  info by carrier ID
   */
  loadCarrierApprovalInfo(carrierId: any) {
    this.transTypeDomestic = false;
    this.transTypeInternational = false;

    this.hhgCarrierRateFilingService.getCarrierApprovalInfo(carrierId).subscribe(res => {
      this.carrierApprovalInfo = res;
      if (this.carrierApprovalInfo && this.carrierApprovalInfo.length > 0) {
        for (const carrierApproval of this.carrierApprovalInfo) {
          if (carrierApproval.approvalType === CAI.DOMESTICHHG) {
            this.shouldHideGeneralDomesticTransType(carrierApproval);
          }
          if (carrierApproval.approvalType === CAI.DOMESTICHHG && carrierApproval.revoked == false) {
            this.transTypeDomestic = true;
          } else if (carrierApproval.approvalType === CAI.INTERNATIONALHHG && carrierApproval.revoked == false) {
            this.transTypeInternational = true;
          }
        }
        this.loadTransType();
      }
    }, (error: any) => {
      this.alertService.error('TSP Approval Info values are unable to load. Please contact administrator or try again after sometime.');
    });
  }

  loadTransType(){
    if(this.transTypeDomestic && this.transTypeInternational){
      this.transTypeList = this.staticTransTypeList;
    }else{
      if(this.transTypeDomestic){
        this.transTypeList = this.staticTransTypeList.filter(x =>  x.value === TT.GENERALDOMESTIC || x.value === TT.DOMESTICMOVEMANAGEMENT);
      }
      if(this.transTypeInternational){
        this.transTypeList = this.staticTransTypeList.filter(x =>  x.value === TT.GENERALINTERNATIONAL || x.value === TT.INTERNATIONALMOVEMANAGEMENT);
      }
    }
    this.loadTransTypetoUI();
  }

  loadTransTypetoUI(){
    if(this.hideGeneralDomesticTransType && !this.hasMcNumber){
      this.transTypeList = this.transTypeList.filter(x => x.value !== TT.GENERALDOMESTIC);
    }else{
     const generalDomesticExists = this. transTypeList.some(x => x.value === TT.GENERALDOMESTIC);
    
      if (!generalDomesticExists) {
          this.transTypeList.push({
              name: TT.GENERALDOMESTIC,
              value: TT.GENERALDOMESTIC
          });
      }
    }
  }

  changeReportingQtrYear(event: any){
    const [selectedYear, selectedQuarter] = event.split('-').map(Number);
    if(selectedYear > 2025 || (selectedYear === 2025 && selectedQuarter >= 2)) this.hideGeneralDomesticTransType = true;
    else this.hideGeneralDomesticTransType = false;
    this.loadTransTypetoUI();
  }

  changeMoveType(event: any){
    const selectedVal = event.target.value;
    this.loadTransType();
  }

  // This function to submit the Negative Shipment Report form values
  submitReport(formSelect: any) {
    this.loader.show();
    this.iffShipmentDetailsService.submitNegativeShipmentReport(formSelect).subscribe(reportStatus => {
      this.reportStatus = reportStatus;
      if (reportStatus.response == 'SUCCESS') {
        this.reportMessage = 'sucess '
        this.reportSubmissionSuccess = true;
        this.reportSubmissionFailure = false;
      } else if (reportStatus.response == 'DUPLICATE' || reportStatus.response == 'Pending') {
        this.reportSubmissionFailure = true;
        this.reportSubmissionSuccess = false;
      } 
    }, (error) => {
      this.alertService.error(error);
      console.log('Error.......... ', error);
      this.loader.hide();
    }, () => {
      this.loader.hide();
    });
  }
}
